<script lang="ts" setup>
import logo from '@csm/template/assets/logo/online.svg?raw'

withDefaults(
  defineProps<{
    width?: number
    color?: string
  }>(),
  {
    width: 110,
    color: 'gray-900'
  },
)
</script>

<template>
  <router-link
    to="/"
    class="app-logo select-none text-inherit"
    :style="{
      display: 'block',
      width: '100%',
      maxWidth: `${width}px`,
      lineHeight: 1,
    }"
    v-html="logo"
  />
</template>

<style lang="scss" scoped>
.app-logo {
  transition: opacity 0.3s;

  &:hover {
    opacity: .6;
  }
}
</style>
